// @flow

import React, { Component } from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import classNames from "classnames";
import { TitleSection, Button, Loader, SectionComponent, View } from "@components";
import { StandartReportsLayout, MyReportsTable } from "@modules/reporting/components";

import type { State } from "@store/reducers";
import type { AddEditReportModalType } from "@modules/reporting/reducer/modals/types";

type Props = $Exact<{
  clientId: number,
  defaultReports: Array<Object>,
  myReports: Array<Object>,
  standardTitle: string,

  getReport: Function,
  deleteReport: Function,
  toggleAddEditModal: Function,
  toggleHelpPanel?: Function,
  ...PropsFromLocalize,
}>;
type myReportsFilterCriteriaType = "ALL" | "RECENT";
type LocalState = $Exact<{
  myReportsFilter: myReportsFilterCriteriaType,
}>;

export class ReportsPageLayout extends Component<Props, LocalState> {
  state = {
    myReportsFilter: "ALL",
  };

  filterReports = (criteria: myReportsFilterCriteriaType) => () => {
    this.setState({
      ...this.state,
      myReportsFilter: criteria || "ALL",
    });
  };
  get myReports() {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    return this.state.myReportsFilter === "ALL"
      ? this.props.myReports
      : this.props.myReports.filter((report: Object) => {
          return new Date(report.createdAt) >= sevenDaysAgo;
        });
  }
  render() {
    return (
      <>
        <StandartReportsLayout
          reports={this.props.defaultReports}
          runReport={this.props.getReport}
          title={this.props.standardTitle}
          toggleHelpPanel={this.props.toggleHelpPanel}
        />
        <View gap={4}>
          <View direction="row" justifyContent="center" alignItems="center">
            <div className="sub-header d-flex w-100 align-items-center">
              <h5 className="sub-header px-0 mr-3">{this.props.t("MY_REPORTS")}</h5>
              <div className="d-flex justify-content-between align-items-center">
                <Button
                  materialIcon="select_all"
                  className={"mr-2 " + (this.state.myReportsFilter === "ALL" ? "active" : "")}
                  onClick={this.filterReports("ALL")}
                >
                  {this.props.t("ALL")}
                </Button>
                <Button
                  materialIcon="history"
                  className={this.state.myReportsFilter === "RECENT" ? "active" : ""}
                  onClick={this.filterReports("RECENT")}
                >
                  {this.props.t("RECENT")}
                </Button>
              </div>
            </div>
            <Button
              onClick={this.props.toggleAddEditModal({
                visible: true,
                initialStep: 1,
              })}
              materialIcon="add_circle"
              className="float-right"
            >
              {this.props.t("NEW_REPORT_CREATE")}
            </Button>
          </View>
          <MyReportsTable
            reports={this.myReports}
            runReport={this.props.getReport}
            clientId={this.props.clientId}
            deleteReport={this.props.deleteReport}
          />
        </View>
      </>
    );
  }
}

export default compose(localize())(ReportsPageLayout);
